module.exports = __webpack_public_path__ + "static/media/background-image.153a822f.jpg";